import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BankAccountDataService } from '../../services/bank-account-data.service';

import { CommonService } from '../../services/common/common.service';

@Component({
  selector: 'app-account-card',
  templateUrl: './account-card.component.html',
  styleUrls: ['./account-card.component.scss']
})
export class AccountCardComponent implements OnInit {
  accountCardValue: any;
  fipList = [];
  bankLogos: any;
  firstTimeLogin: any;
  breadcrumb: { "label": string; "link": any[]; }[] = [];
  selectedFip: { "FIPName": string; "FIPID": string; };
  constructor(
    private route: Router,
    private commonService : CommonService,
    private accService: BankAccountDataService) {
    }

  ngOnInit() {
    this.getFipList();
    this.getBankLogos();
    this.setBreadcrumb();
  }
  getAccountCardValue(form) {
    if (form.valid) {
      this.fipList.forEach(element => {
        if(element.fipID == this.accountCardValue){
          this.selectedFip = {
            "FIPName":""+element.fipName ,
            "FIPID": "" + this.accountCardValue + "",
          }
        }
      });
      

      this.accService.setSelectedFip(this.selectedFip);
      this.route.navigate(['/account-discover']);
    }
  }

  getBankLogos() {
    this.accService.getBanksLogos().subscribe((res) => {
      if (res != undefined) {
        this.bankLogos = res;
        this.firstTimeLogin = localStorage.getItem('newUser');
      }
    });
  }
  getFipList(){
    this.commonService.getFIPList().subscribe(res => {
        this.fipList = res;
    });
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Select Bank Account", "link": ["/dashboard"] },
    ];
  }
}
